import React, { FC, useMemo } from "react";
import { Gem } from "@styled-icons/bootstrap";
import { useTranslation } from "react-i18next";

import {
  TStudentIdealMatch,
  TStudentMatchCharacteristics
} from "../../../interfaces/interfaces";
import { OverviewInfoContainer } from "../../../components/containers";
import { TitleH3, TitleH4 } from "../../../components/generic";
import { StewpanIcon } from "../../../components/Icons/studentOverview";

import { InfoWithIconWrapper } from "../styles";

type ExpectationsType = {
  idealMatch?: TStudentIdealMatch[];
  matchCharacteristics?: TStudentMatchCharacteristics[];
  children?: never;
};
export const Expectations: FC<ExpectationsType> = ({
  idealMatch,
  matchCharacteristics
}) => {
  const { t } = useTranslation("matches");

  const [areIdealMatches, areMatchCharacteristics] = useMemo(() => {
    return [
      typeof idealMatch !== "undefined" && idealMatch.length > 0,
      typeof matchCharacteristics !== "undefined" &&
        matchCharacteristics.length > 0
    ];
  }, [idealMatch, matchCharacteristics]);

  return (
    <>
      {(areIdealMatches || areMatchCharacteristics) && (
        <OverviewInfoContainer margin="0 0 40px">
          <TitleH3 m="0 0 2rem" color="hardGray" fontSize="sizeTitle">
            {t(`host.userInfo.expectations`)}
          </TitleH3>
          {areIdealMatches && (
            <>
              <TitleH4
                m="0 0 8px"
                fW="weightMedium"
                c="hardGray"
                lineHeight="1.5rem"
              >
                {t(`host.userInfo.idealMatchTitle`)}
              </TitleH4>
              <InfoWithIconWrapper isCentered>
                <StewpanIcon />
                <p>
                  {t(`host.userInfo.idealMatch.beginning`)}{" "}
                  {idealMatch!.map((item, idx) => (
                    <span key={item}>
                      {" "}
                      {idx === idealMatch!.length - 1 && idealMatch!.length > 1
                        ? t(`host.userInfo.and`)
                        : t(`host.userInfo.idealMatch.to`)}{" "}
                      {t(`host.userInfo.idealMatch.options.${item}`)}
                      {idx < idealMatch!.length - 2 &&
                        idealMatch!.length > 2 &&
                        ", "}
                    </span>
                  ))}{" "}
                  {t(`host.userInfo.idealMatch.end`)}
                </p>
              </InfoWithIconWrapper>
            </>
          )}
          {areMatchCharacteristics && (
            <>
              <TitleH4
                m="0 0 8px"
                fW="weightMedium"
                c="hardGray"
                lineHeight="1.5rem"
              >
                {t(`host.userInfo.matchCharacteristicsTitle`)}
              </TitleH4>
              <InfoWithIconWrapper isCentered>
                <Gem size="1.5rem" />
                <p>
                  {matchCharacteristics!.map((item, idx) => (
                    <span key={item}>
                      {" "}
                      {idx === matchCharacteristics!.length - 1 &&
                        matchCharacteristics!.length > 1 &&
                        t(`host.userInfo.and`)}{" "}
                      {t(`host.userInfo.matchCharacteristics.${item}`)}
                      {idx < matchCharacteristics!.length - 2 &&
                        matchCharacteristics!.length > 2 &&
                        ", "}
                    </span>
                  ))}
                </p>
              </InfoWithIconWrapper>
            </>
          )}
        </OverviewInfoContainer>
      )}
    </>
  );
};
